import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

export async function fetchAllInventoryAuditorLocations(): Promise<any[]> {
  const response = await httpClient.post('api/inventory-auditor/location/query', {
    skip: 0,
    take: 1000,
    search: '',
    orderBy: 'id',
    orderDirection: 'ASC',
  });
  return response.data.data || [];
}

export const useInventoryAuditorLocationsList = () => {
  return useQuery({
    queryKey: ['inventory-auditor-locations'],
    queryFn: fetchAllInventoryAuditorLocations,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useCreateInventoryAuditorLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Record<string, unknown>) => {
      const response = await httpClient.post('api/inventory-auditor/location/create', payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory-auditor-locations'] });
    },
  });
};

export const useInventoryAuditorLocationDetails = (locationId: string | undefined) => {
  return useQuery({
    queryKey: ['inventory-auditor-location-details', locationId],
    queryFn: async () => {
      const response = await httpClient.get('api/inventory-auditor/location/details', {
        id: locationId,
      });
      return response.data;
    },
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useUpdateInventoryAuditorLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Record<string, unknown>) => {
      const response = await httpClient.post('api/inventory-auditor/location/update', payload);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      const id = variables?.id;
      if (id != null) {
        queryClient.invalidateQueries({ queryKey: ['inventory-auditor-location-details', String(id)] });
      }
      queryClient.invalidateQueries({ queryKey: ['inventory-auditor-locations'] });
    },
  });
};
